import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { MapStore } from 'store/map'
import { PlaceMarker } from 'ui/common/place-marker'
import { useDebounceValue } from 'usehooks-ts'
import { GpsBounds } from 'infra/type.ts'
import { placeMarkersCacheStore } from 'store/place-markers-cache-store.ts'
import { placesStore } from 'store/places.ts'
import { categoryFilterStore } from 'store/category-filter'

export const PlaceMarkers: React.FC<{
  mapStore: MapStore
}> = observer(({ mapStore }) => {
  const [bounds, setBounds] = useDebounceValue<GpsBounds | null>(
    mapStore.rangeBounds,
    100,
  )
  useEffect(() => {
    setBounds(mapStore.rangeBounds)
  }, [setBounds, mapStore.rangeBounds])
  useEffect(() => {
    const places = placesStore.getPlacesWithinBounds(bounds)
    placeMarkersCacheStore.save(places)
  }, [bounds])
  const filteredPlaces = (() => {
    if (!categoryFilterStore.isFiltering) {
      return placeMarkersCacheStore.places
    }
    const selectedCategoryId = categoryFilterStore.selectedCategory?.id
    if (selectedCategoryId === undefined) return placeMarkersCacheStore.places
    return placeMarkersCacheStore.places.filter((place) =>
      place.categories.includes(selectedCategoryId),
    )
  })()

  return (
    <>
      {filteredPlaces.map((v) => (
        <PlaceMarker key={v.id} place={v} mapStore={mapStore} />
      ))}
    </>
  )
})
